import React from 'react';
import { BrandsAPI } from '../../../../constructs/brands/interface';
import { useAPIContext } from '../../context/api';

export const useDownloadMedia = () => {
  const { callEndpoint } = useAPIContext();

  const downloadBannerZip = React.useCallback(
    async (bannerId: string) => {
      const response = await callEndpoint<BrandsAPI, 'download-banner-zip'>(
        'brands',
        `/banners/${bannerId}/download`,
        'GET'
      );

      const link = document.createElement('a');
      link.href = response.downloadUrl;
      link.download = `banner-${bannerId}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return response;
    },
    [callEndpoint]
  );

  return { downloadBannerZip };
};
